import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { InputDataUrl } from './InputDataUrl';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';

const postInputDataDetailsPreview = async (
  params: { sessionId: string },
  headers?: HttpHeaders,
) =>
  apiClient
    .post(
      expand(InputDataUrl.INPUT_DATA_DETAILS_PREVIEW, params),
      undefined,
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useInputDataDetailsPreviewMutation = createApiMutationHook(
  ['inputDataDetailsPreviewMutation'],
  getMutationFn(postInputDataDetailsPreview),
);
